import SearchPagination from '@react/search/components/SearchPagination';
import { RESOURCE_CENTER_PATH } from '@sly/core/constants/dashboardAppPaths';
import cx from 'classnames';
import { array, number, string } from 'prop-types';
import ArticlePreview from 'sly/resourceCenter/components/ArticlePreview';
import {
  ARTICLES_RANGE_FOR_PAGINATION,
  getPaginationProperties,
} from 'sly/resourceCenter/helpers';
import Heading from 'sly/system/Heading';

const AuthorArticles = ({
  slug,
  firstName,
  pageNumber,
  articlesCount,
  articlesList,
  type = 'author',
}) => {
  const pagination = getPaginationProperties({
    basePath: `${RESOURCE_CENTER_PATH}/${type}/${encodeURIComponent(slug)}`,
    count: articlesCount,
    current: pageNumber,
  });
  return (
    <>
      <div data-tp-id='gen-div-2fac57b9-e9bf-49f0-b8d1-a498bafde253'>
        <Heading
          className='font-t-l mb-xl'
          data-tp-id='gen-Heading-32b69cd4-e388-43c3-a4a9-2b29c6a01d09'
        >
          {articlesCount
            ? `${firstName}'s article${articlesCount > 1 ? 's' : ''}`
            : `${firstName} has no articles yet`}
        </Heading>
        <div
          className={cx(
            'grid grid-flow-row grid-cols-[auto] gap-l md:grid-cols-2 lg:grid-cols-3',
            articlesCount <= 3 && 'mb-xxl md:mb-20'
          )}
          data-tp-id='gen-div-9130a583-bf51-4dbb-ba83-ea680b37ae64'
        >
          {articlesList?.map(
            // TODO remove ? when articles aren't loaded after
            ({
              title,
              shortDescription,
              mainImg,
              slug,
              mainTopic,
              tagsList,
              id,
            }) => (
              <div
                key={id}
                data-tp-id='gen-div-ec46750e-f1f0-46e6-a85c-84ef42706c37'
              >
                <ArticlePreview
                  {...{
                    alternativeText: mainImg?.alternativeText,
                    title,
                    shortDescription,
                    path: mainImg?.path,
                    topic: mainTopic,
                    tagsList,
                    to: `${RESOURCE_CENTER_PATH}/${mainTopic.slug}/${slug}`,
                    key: id,
                  }}
                />
              </div>
            )
          )}
        </div>
      </div>

      {articlesCount && (
        <div
          className='my-xxl mx-auto w-max'
          data-tp-id='gen-div-a6568b8f-dcd4-4ba4-a267-80475515ae68'
        >
          {articlesCount > ARTICLES_RANGE_FOR_PAGINATION && (
            <SearchPagination pagination={pagination} />
          )}
        </div>
      )}
    </>
  );
};

AuthorArticles.propTypes = {
  slug: string,
  firstName: string,
  pageNumber: string,
  articlesCount: number,
  articlesList: array,
};

export default AuthorArticles;
